export const SUBSCRIPTION_REQUIRED_EVENT = "muycoach:subscription-required";

// La API responde 402 SUBSCRIPTION_REQUIRED cuando el coach no tiene acceso de pago
// (trial o período de gracia vencidos). Aquí no se redirige con un reload: la sesión
// persistida en Redux puede tener un payment desactualizado (solo se refresca con
// /auth/me al iniciar sesión), así que el reload mete al coach en un loop entre "/"
// y /payment. En su lugar se avisa por evento: Routes.js refresca el payment con
// /auth/me y el efecto de getPaymentRedirect (src/Utils/subscriptionAccess.js) hace
// el history.push a /payment, sin reload.
export const handleSubscriptionRequired = (error) => {
    if (
        error?.response?.status === 402 &&
        error.response.data?.code === "SUBSCRIPTION_REQUIRED"
    ) {
        window.dispatchEvent(new CustomEvent(SUBSCRIPTION_REQUIRED_EVENT));
    }
    return Promise.reject(error);
};

// En una pantalla pueden fallar varios requests de negocio con 402 casi al mismo
// tiempo: sin este mínimo entre llamados se haría un /auth/me por cada 402. Por eso
// se ignora toda llamada mientras una sigue corriendo o cuando aún no pasó
// minIntervalMs desde que empezó la anterior.
export const makePaymentRefresher = ({
    fetchMe,
    onPayment,
    minIntervalMs = 15000,
    now = () => Date.now(),
}) => {
    let running = false;
    let lastStart = -Infinity;

    return async () => {
        const at = now();
        if (running || at - lastStart < minIntervalMs) {
            return;
        }
        running = true;
        lastStart = at;
        try {
            const response = await fetchMe();
            if (response?.data?.payment && typeof response.data.payment === "object") {
                onPayment(response.data.payment);
            }
        } catch (error) {
            // Si /auth/me falla no se rompe nada: el 402 ya llegó a la pantalla
            // que lo originó y el coach puede reintentar más tarde.
            console.warn("No se pudo refrescar el payment tras un 402", error);
        } finally {
            running = false;
        }
    };
};
